import React from "react";
import PlaceHolder from "../assets/Placeholder.jpg";
import { FaArrowRight } from "react-icons/fa";
import Productivity from "../assets/Productivity.jpg";
import MovieDB from "../assets/moviedb.PNG";
import ReactIcon from "../assets/react.png";
import JavaScript from "../assets/javascript.png";
import Tailwind from "../assets/tailwind.png";
import Firebase from "../assets/firebase.png";
import Showcase from "../assets/showcase.PNG";
import WeatherApp from "../assets/weatherapp.PNG";
import NextJS from "../assets/next-js.png";
import TypeScript from "../assets/typescript.png";

const Work = () => {
  return (
    <div name="work" className="darkgray w-full py-28 text-slate-300">
      <div className="mx-auto flex w-full max-w-[1000px] flex-col justify-center px-8 md:h-full">
        <div className="pb-8">
          <p className="inline border-b-4 border-yellow-400 text-4xl font-bold">
            Work
          </p>
        </div>

        {/*Container*/}
        <div className="flex flex-col space-y-24">
          {/* item 1 */}
          <div className="flex flex-col space-y-8">
            <img src={MovieDB} className="w-fit rounded-lg object-cover" />
            <div className="flex flex-col space-y-12">
              {/* Description */}
              <div>
                <h1 className="text-3xl font-semibold">movie.db</h1>
                <div className="py-4 text-slate-400">
                  <p>
                    movie.db is a modern web application providing comprehensive
                    information about movies, including detailed synopses, cast,
                    crew, and ratings by fetching real-time data from themovieDB
                    API. It features a user-friendly interface, dynamic
                    animations, and secure user authentication using Google
                    Firebase.
                  </p>
                </div>
                <div className="grid w-fit grid-cols-4 gap-8">
                  <img src={ReactIcon} className="w-6" />
                  <img src={JavaScript} className="w-6" />
                  <img src={Tailwind} className="w-6" />
                  <img src={Firebase} className="w-6" />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-row items-center space-x-8">
                <a href="https://github.com/sjhmichael/movie-database">
                  <button className="group flex flex-row items-center text-lg hover:text-yellow-400">
                    GitHub
                    <FaArrowRight className="ml-2 duration-300 group-hover:translate-x-2" />
                  </button>
                </a>
                <a href="https://sjh-movie-database.vercel.app/">
                  <button className="group flex flex-row items-center rounded-full bg-yellow-400 p-2 px-5 text-lg text-black duration-300 hover:bg-neutral-800 hover:px-8 hover:text-yellow-400">
                    Website
                    <FaArrowRight className="ml-2 duration-300 group-hover:translate-x-2" />
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* item 2 */}
          <div className="flex flex-col space-y-8">
            <img src={Showcase} className="w-fit rounded-lg object-cover" />
            <div className="flex flex-col space-y-12">
              {/* Description */}
              <div>
                <h1 className="text-3xl font-semibold">Atomic Design System</h1>
                <div className="py-4 text-slate-400">
                  <p>
                    Atomic Design System showcases a comprehensive design system
                    that provides a consistent visual language and set of design
                    principles. It features a collection of reusable components,
                    styles, and guidelines to ensure cohesive and efficient
                    design and development processes.
                  </p>
                </div>
                <div className="grid w-fit grid-cols-4 gap-8">
                  <img src={NextJS} className="w-6" />
                  <img src={TypeScript} className="w-6" />
                  <img src={Tailwind} className="w-6" />
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-row items-center space-x-8">
                <a href="https://github.com/sjhmichael/design-system-showcase">
                  <button className="group flex flex-row items-center text-lg hover:text-yellow-400">
                    GitHub
                    <FaArrowRight className="ml-2 duration-300 group-hover:translate-x-2" />
                  </button>
                </a>
                <a href="https://sjh-design-system.vercel.app/">
                  <button className="group flex flex-row items-center rounded-full bg-yellow-400 p-2 px-5 text-lg text-black duration-300 hover:bg-neutral-800 hover:px-8 hover:text-yellow-400">
                    Website
                    <FaArrowRight className="ml-2 duration-300 group-hover:translate-x-2" />
                  </button>
                </a>
              </div>
            </div>
          </div>

          {/* item 2 */}
          {/*
          <div className="flex flex-row space-x-8">
            <div className="w-[1000px]">
              <img src={WeatherApp} className="rounded-lg w-fit object-cover" />
            </div>
            <div className="flex flex-col space-y-12">
              <div>
                <h1 className="text-3xl font-semibold">Weather App</h1>
                <div className="py-4 text-slate-400">
                  <p>
                    Atomic Design System showcases a comprehensive design system
                    that provides a consistent visual language and set of design
                    principles. It features a collection of reusable components,
                    styles, and guidelines to ensure cohesive and efficient
                    design and development processes.
                  </p>
                </div>
                <div className="grid grid-cols-4 w-fit gap-8">
                  <img src={NextJS} className="w-6" />
                  <img src={TypeScript} className="w-6" />
                  <img src={Tailwind} className="w-6" />
                </div>
              </div>


              <div className="flex flex-row space-x-8">
                <a href="https://sjh-movie-database.vercel.app/">
                  <button className="group font-semibold text-lg hover:text-yellow-400 flex flex-row items-center">
                    GitHub
                    <FaArrowRight className="ml-2 group-hover:translate-x-2 duration-300" />
                  </button>
                </a>
                <a href="/">
                  <button className=" font-semibold text-lg hover:text-yellow-400 flex flex-row items-center">
                    Website
                    <FaArrowRight className="ml-2" />
                  </button>
                </a>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Work;
